/* ==========================================================================
   Product landing page renderer.
   Reads window.RG_CONFIG and renders the full page into #rg-root.
   cart.mode: "demo" (preview, no real cart) | "shopify" (adds to cart via /cart/add.js)
   ========================================================================== */
(function () {
  "use strict";

  /* ---------- Shopify: build the page config from theme-editor settings ---------- */
  function fromShopify(d) {
    var s = d.s || {}, blocks = (d.blocks || []).filter(Boolean);
    d.media = (d.media || []).filter(Boolean);
    var set = function (v) { return v !== null && v !== undefined && String(v).trim() !== ""; };
    var e = function (v) { return String(v == null ? "" : v).replace(/[&<>]/g, function (c) { return { "&": "&amp;", "<": "&lt;", ">": "&gt;" }[c]; }); };
    var num = function (v, dflt) { v = parseFloat(v); return isNaN(v) ? dflt : v; };
    var C = {
      brand: d.brand || {},
      chrome: { announce: false, header: false, footer: false },
      cart: { mode: "shopify", currency: d.currency || "$", after: s.after_add || "cart" },
      product: {
        title: e(s.title_main) + (set(s.title_accent) ? " <em>" + e(s.title_accent) + "</em>" : ""),
        badge: s.badge,
        pills: [],
        rating: set(s.rating_score) ? { score: s.rating_score, count: s.rating_count } : null,
        bullets: [s.bullet_1, s.bullet_2, s.bullet_3, s.bullet_4, s.bullet_5].filter(set),
        images: d.media && d.media.length ? d.media : [],
        stickyImg: d.media && d.media[0] ? d.media[0].thumb : ""
      },
      sale: set(s.sale_end) ? { label: s.sale_label, endsAt: s.sale_end } : null,
      bundleMode: s.bundle_mode || "quantity",
      bundleLabel: s.bundle_label, bundleSub: s.bundle_sub || "", slotUnit: s.slot_unit || "Pair",
      designLabel: s.design_label, designHint: s.design_hint, propLabel: s.prop_label || "Design",
      atcLabel: s.atc_label || "Add to cart", atcShort: s.atc_label || "Add to cart",
      trust: [s.trust_1, s.trust_2, s.trust_3].filter(set),
      payments: [],
      shipping: s.show_shipping === false ? null : { prepMin: num(s.prep_min, 2), prepMax: num(s.prep_max, 4), shipMin: num(s.ship_min, 5), shipMax: num(s.ship_max, 9) },
      quote: set(s.quote_text) ? { text: s.quote_text, name: s.quote_name, verified: true, stars: 5 } : null,
      sections: [], reviews: [], faq: []
    };
    if (set(s.pill_1)) C.product.pills.push({ text: s.pill_1, hot: true });
    if (set(s.pill_2)) C.product.pills.push({ text: s.pill_2, live: true });

    // bundles
    var tiers = [];
    for (var i = 1; i <= 3; i++) {
      if (!set(s["tier_" + i + "_name"])) continue;
      var q = Math.max(1, num(s["tier_" + i + "_qty"], i));
      tiers.push({ n: i, name: s["tier_" + i + "_name"], sub: s["tier_" + i + "_sub"], qty: q, designs: q,
        discount: num(s["tier_" + i + "_discount"], 0), tag: s["tier_" + i + "_tag"], tagAlt: i === 3, default: num(s.tier_default, 2) === i });
    }
    var vs = d.variants || [], base = d.base;
    if (C.bundleMode === "quantity" && base) {
      tiers.forEach(function (t) {
        t.variantId = base.id;
        t.price = Math.round(base.price * t.qty * (100 - t.discount) / 100) / 100;
        t.compare = base.compare_at_price && base.compare_at_price > base.price ? base.compare_at_price * t.qty / 100 : null;
      });
    } else {
      tiers.forEach(function (t, k) {
        var v = vs[k]; if (!v) return;
        t.variantId = v.id; t.price = v.price / 100; t.qty = 1; t.designs = num(s["tier_" + t.n + "_qty"], 1);
        t.compare = v.compare_at_price && v.compare_at_price > v.price ? v.compare_at_price / 100 : null;
        if (!v.available) t.soldOut = true;
      });
      tiers = tiers.filter(function (t) { return t.variantId && !t.soldOut; });
    }
    if (!tiers.length && base) tiers = [{ name: d.title || "", sub: "", qty: 1, designs: 1, price: base.price / 100, compare: base.compare_at_price ? base.compare_at_price / 100 : null, variantId: base.id }];
    if (!tiers.some(function (t) { return t.default; }) && tiers[0]) tiers[Math.min(1, tiers.length - 1)].default = true;
    C.tiers = tiers;

    C.designs = blocks.filter(function (b) { return b.type === "design" && b.img; }).map(function (b) { return { name: b.name || "Design", img: b.img }; });
    C.info = blocks.filter(function (b) { return b.type === "info" && set(b.title); }).map(function (b) { return { q: b.title, a: b.text || "" }; });
    if (d.upsell) C.upsell = { variantId: d.upsell.id, price: d.upsell.price / 100, title: set(s.upsell_title) ? s.upsell_title : d.upsell.title, desc: s.upsell_desc, img: d.upsell.img };
    return C;
  }

  function boot() {
    var root = document.getElementById("rg-root");
    if (!root) return;
    var j = document.getElementById("rg-config");
    var C = j ? fromShopify(JSON.parse(j.textContent)) : window.RG_CONFIG;
    if (!C) return;
    if (window.__rgTimer) clearInterval(window.__rgTimer);
    render(C, root);
  }

  function render(C, root) {

  var cur = (C.cart && C.cart.currency) || "$";
  var money = function (n) { return cur + Number(n).toFixed(2); };
  var esc = function (s) {
    return String(s == null ? "" : s).replace(/[&<>"']/g, function (c) {
      return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c];
    });
  };
  var stars = function (n) { n = Math.round(n || 5); return "★★★★★".slice(0, n) + "☆☆☆☆☆".slice(0, 5 - n); };
  var icon = {
    truck: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M1 3h15v13H1zM16 8h4l3 3v5h-7"/><circle cx="5.5" cy="18.5" r="2.5"/><circle cx="18.5" cy="18.5" r="2.5"/></svg>',
    shield: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/><path d="M9 12l2 2 4-4"/></svg>',
    lock: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="11" width="18" height="11" rx="2"/><path d="M7 11V7a5 5 0 0110 0v4"/></svg>',
    cart: '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/><path d="M1 1h4l2.7 13.4a2 2 0 002 1.6h9.7a2 2 0 002-1.6L23 6H6"/></svg>'
  };

  /* ---------- state ---------- */
  var tiers = C.tiers || [];
  var designs = C.designs || [];
  var state = {
    tier: Math.max(0, tiers.findIndex(function (t) { return t.default; })),
    picks: [],      // design index per slot
    slot: 0,
    upsell: false,
    count: 0
  };
  function slotsFor(t) { return Math.max(1, (tiers[t] && tiers[t].designs) || 1); }
  function syncPicks() {
    var n = slotsFor(state.tier);
    while (state.picks.length < n) state.picks.push(state.picks.length ? state.picks[state.picks.length - 1] : 0);
    state.picks.length = n;
    if (state.slot >= n) state.slot = 0;
  }
  syncPicks();

  /* ---------- builders ---------- */
  function announce() {
    if (!C.announce || !C.announce.length) return "";
    var items = C.announce.map(function (a) { return "<span>" + esc(a) + "</span>"; }).join("");
    return '<div class="rg-announce" role="region" aria-label="Announcements"><div class="rg-announce__track"><span>' + items + "</span><span aria-hidden=\"true\">" + items + "</span></div></div>";
  }
  function header() {
    var b = C.brand || {};
    var logo = b.logoImg ? '<img src="' + esc(b.logoImg) + '" alt="' + esc(b.name) + '">' : esc(b.logoTop || b.name) + (b.logoBottom ? "<small>" + esc(b.logoBottom) + "</small>" : "");
    return '<header class="rg-header"><div class="rg-wrap rg-header__in"><span style="width:40px"></span><a class="rg-logo" href="' + esc(b.homeUrl || "#") + '">' + logo + '</a><button class="rg-header__cart" aria-label="Cart" data-act="cart">' + icon.cart + '<span class="rg-header__count" data-el="count">0</span></button></div></header>';
  }
  function gallery() {
    var imgs = (C.product.images || []);
    var slides = imgs.map(function (m, i) {
      var inner = m.video
        ? '<video src="' + esc(m.video) + '" ' + (m.src ? 'poster="' + esc(m.src) + '"' : "") + ' muted loop playsinline autoplay></video>'
        : '<img src="' + esc(m.src) + '" alt="' + esc(m.alt || "") + '"' + (i ? ' loading="lazy"' : "") + ">";
      return '<div class="rg-gallery__slide">' + inner + "</div>";
    }).join("");
    var thumbs = imgs.length > 1 ? '<div class="rg-gallery__thumbs">' + imgs.map(function (m, i) {
      return '<button data-thumb="' + i + '" class="' + (i ? "" : "on") + '" aria-label="Image ' + (i + 1) + '"><img src="' + esc(m.thumb || m.src) + '" alt=""></button>';
    }).join("") + "</div>" : "";
    var dots = imgs.length > 1 ? '<div class="rg-gallery__dots">' + imgs.map(function (m, i) { return "<i class=\"" + (i ? "" : "on") + "\"></i>"; }).join("") + "</div>" : "";
    var badge = C.product.badge ? '<span class="rg-gallery__badge">' + esc(C.product.badge) + "</span>" : "";
    return '<div class="rg-gallery"><div class="rg-gallery__main"><div class="rg-gallery__slides" data-el="slides">' + slides + "</div>" + badge + dots + "</div>" + thumbs + "</div>";
  }
  function pills() {
    var p = C.product.pills || [];
    if (!p.length) return "";
    return '<div class="rg-info__pills">' + p.map(function (x) {
      return '<span class="rg-pill' + (x.hot ? " rg-pill--hot" : "") + '">' + (x.live ? '<span class="rg-pill__dot"></span>' : "") + esc(x.text) + "</span>";
    }).join("") + "</div>";
  }
  function rating() {
    var r = C.product.rating;
    if (!r || !r.score) return "";
    return '<div class="rg-rating"><span class="rg-stars">' + stars(r.score) + "</span><b>" + esc(r.score) + "/5</b> " + (r.count ? "· " + esc(r.count) + " reviews" : "") + "</div>";
  }
  function priceBlock() {
    return '<div class="rg-price" data-el="price"></div>';
  }
  function bullets() {
    var b = C.product.bullets || [];
    return b.length ? '<ul class="rg-bullets">' + b.map(function (x) { return "<li>" + esc(x) + "</li>"; }).join("") + "</ul>" : "";
  }
  function timer() {
    if (!C.sale || !C.sale.endsAt) return "";
    return '<div class="rg-timer" data-el="timer"><span>' + esc(C.sale.label || "Sale ends in") + '</span><span class="rg-timer__clock"><b data-t="d">00</b><b data-t="h">00</b><b data-t="m">00</b><b data-t="s">00</b></span></div>';
  }
  function bundles() {
    if (!tiers.length) return "";
    return '<div class="rg-label">' + esc(C.bundleLabel || "Bundle & save") + "<span>" + esc(C.bundleSub || "") + '</span></div><div class="rg-bundles" role="radiogroup">' + tiers.map(function (t, i) {
      var save = t.compare ? Math.round((1 - t.price / t.compare) * 100) : 0;
      return '<button class="rg-bundle" role="radio" data-tier="' + i + '">' +
        (t.tag ? '<span class="rg-bundle__tag' + (t.tagAlt ? " rg-bundle__tag--alt" : "") + '">' + esc(t.tag) + "</span>" : "") +
        '<span class="rg-bundle__radio"></span><span><span class="rg-bundle__name">' + esc(t.name) + '</span><br><span class="rg-bundle__sub">' + esc(t.sub || "") + "</span>" +
        (save > 0 ? '<br><span class="rg-bundle__save">You save ' + money(t.compare - t.price) + " (" + save + "%)</span>" : "") +
        '</span><span class="rg-bundle__price"><b>' + money(t.price) + "</b>" + (t.compare ? "<s>" + money(t.compare) + "</s>" : "") + "</span></button>";
    }).join("") + "</div>";
  }
  function designPicker() {
    if (!designs.length) return "";
    return '<div class="rg-label">' + esc(C.designLabel || "Choose your design") + ' <span data-el="designName"></span></div>' +
      '<div class="rg-slots" data-el="slots"></div>' +
      '<div class="rg-designs">' + designs.map(function (d, i) {
        return '<button class="rg-design" data-design="' + i + '" aria-label="' + esc(d.name) + '"><span class="rg-design__img"><img src="' + esc(d.img) + '" alt="' + esc(d.name) + '" loading="lazy"></span><span class="rg-design__name">' + esc(d.name) + "</span></button>";
      }).join("") + '</div><p class="rg-designs__hint" data-el="hint"></p>';
  }
  function upsell() {
    var u = C.upsell;
    if (!u || !u.title) return "";
    return '<label class="rg-upsell"><input type="checkbox" data-el="upsell">' +
      (u.img ? '<img src="' + esc(u.img) + '" alt="">' : '<span class="rg-upsell__ph">🎁</span>') +
      '<span><span class="rg-upsell__t">' + esc(u.title) + '</span><br><span class="rg-upsell__d">' + esc(u.desc || "") + '</span></span><span class="rg-upsell__p">+' + money(u.price) + "</span></label>";
  }
  function trust() {
    var t = C.trust || [];
    var ic = [icon.truck, icon.shield, icon.lock];
    return t.length ? '<div class="rg-trust">' + t.map(function (x, i) { return "<div>" + ic[i % 3] + esc(x) + "</div>"; }).join("") + "</div>" : "";
  }
  function payments() {
    var p = C.payments || [];
    return p.length ? '<div class="rg-pay">' + p.map(function (x) { return "<span>" + esc(x) + "</span>"; }).join("") + "</div>" : "";
  }
  function addBiz(d, n) { d = new Date(d); while (n > 0) { d.setDate(d.getDate() + 1); var w = d.getDay(); if (w && w < 6) n--; } return d; }
  function fmt(d) { return d.toLocaleDateString(undefined, { month: "short", day: "numeric" }); }
  function shipping() {
    var s = C.shipping;
    if (!s) return "";
    var now = new Date();
    var a = addBiz(now, s.prepMin), b = addBiz(now, s.prepMax);
    var c = addBiz(now, s.prepMin + s.shipMin), d = addBiz(now, s.prepMax + s.shipMax);
    return '<div class="rg-ship"><div><i>✓</i><b>Ordered</b>' + fmt(now) + '</div><div><i>📦</i><b>Ships</b>' + fmt(a) + "–" + fmt(b) + '</div><div><i>🚗</i><b>Delivered</b>' + fmt(c) + "–" + fmt(d) + "</div></div>";
  }
  function quote() {
    var q = C.quote;
    if (!q || !q.text) return "";
    return '<div class="rg-quote"><span class="rg-stars">' + stars(q.stars || 5) + "</span><p>“" + esc(q.text) + "”</p><small>— " + esc(q.name) + (q.verified ? " · Verified buyer" : "") + "</small></div>";
  }
  function acc(list) {
    if (!list || !list.length) return "";
    return '<div class="rg-acc">' + list.map(function (x, i) {
      return "<details" + (x.open ? " open" : "") + "><summary>" + esc(x.q) + '</summary><div class="rg-acc__body">' + String(x.a).split("\n").map(function (p) { return "<p>" + esc(p) + "</p>"; }).join("") + "</div></details>";
    }).join("") + "</div>";
  }

  /* ---------- content sections ---------- */
  function h2(t) { return '<h2 class="rg-h2">' + t + "</h2>"; } // titles allow <em> on purpose (config is merchant-authored)
  function lead(t) { return t ? '<p class="rg-lead">' + esc(t) + "</p>" : ""; }
  function media(s) {
    if (s.video) return '<div class="rg-media' + (s.dark ? " rg-media--dark" : "") + '"><video src="' + esc(s.video) + '" ' + (s.img ? 'poster="' + esc(s.img) + '"' : "") + ' muted loop playsinline autoplay></video></div>';
    if (s.img) return '<div class="rg-media' + (s.dark ? " rg-media--dark" : "") + '"><img src="' + esc(s.img) + '" alt="' + esc(s.alt || "") + '" loading="lazy"></div>';
    return "";
  }
  var S = {
    split: function (s) {
      var txt = "<div>" + h2(s.title) + lead(s.lead) + (s.feats ? S.featsInner(s.feats) : "") + (s.cta ? '<div style="margin-top:20px"><button class="rg-atc" data-act="scroll">' + esc(s.cta) + "</button></div>" : "") + "</div>";
      return '<section class="rg-sec' + (s.glow ? " rg-sec--glow" : "") + '"><div class="rg-wrap rg-split rg-fade">' + (s.reverse ? txt + media(s) : media(s) + txt) + "</div></section>";
    },
    featsInner: function (f) {
      return '<div class="rg-feats">' + f.map(function (x) { return '<div class="rg-feat"><div class="rg-feat__ic">' + esc(x.icon || "") + "</div><b>" + esc(x.title) + "</b><span>" + esc(x.text) + "</span></div>"; }).join("") + "</div>";
    },
    feats: function (s) { return '<section class="rg-sec"><div class="rg-wrap rg-fade">' + h2(s.title) + lead(s.lead) + S.featsInner(s.items || []) + "</div></section>"; },
    image: function (s) { return '<section class="rg-sec' + (s.glow ? " rg-sec--glow" : "") + '"><div class="rg-wrap rg-fade" style="max-width:760px">' + h2(s.title) + lead(s.lead) + media(s) + "</div></section>"; },
    steps: function (s) {
      return '<section class="rg-sec"><div class="rg-wrap rg-fade">' + h2(s.title) + lead(s.lead) + '<div class="rg-steps">' + (s.items || []).map(function (x) { return '<div class="rg-step"><div><b>' + esc(x.title) + "</b><span>" + esc(x.text) + "</span></div></div>"; }).join("") + "</div>" + (s.img ? '<div style="max-width:640px;margin:22px auto 0">' + media(s) + "</div>" : "") + "</div></section>";
    },
    compare: function (s) {
      var cell = function (v) { return v === true ? '<span class="rg-yes">✓</span>' : v === false ? '<span class="rg-no">✕</span>' : esc(v); };
      return '<section class="rg-sec"><div class="rg-wrap rg-fade">' + h2(s.title) + lead(s.lead) + '<table class="rg-compare"><thead><tr><th></th><th class="us">' + esc(s.us || "Us") + "</th><th>" + esc(s.them || "Others") + "</th></tr></thead><tbody>" +
        (s.rows || []).map(function (r) { return "<tr><td>" + esc(r[0]) + '</td><td class="us">' + cell(r[1]) + "</td><td>" + cell(r[2]) + "</td></tr>"; }).join("") + "</tbody></table></div></section>";
    },
    reviews: function (s) {
      var r = C.reviews || [];
      var body;
      if (r.length) {
        body = '<div class="rg-reviews">' + r.map(function (x) {
          return '<div class="rg-review">' + (x.img ? '<img src="' + esc(x.img) + '" alt="" loading="lazy">' : "") + '<div class="rg-review__b"><span class="rg-stars">' + stars(x.stars) + "</span><b>" + esc(x.title || "") + "</b><p>" + esc(x.text) + '</p><div class="rg-review__n">' + esc(x.name) + (x.verified ? " <span>✓ Verified buyer</span>" : "") + "</div></div></div>";
        }).join("") + "</div>";
      } else if (C.cart && C.cart.mode === "demo") {
        body = '<div class="rg-placeholder">Your real customer reviews go here — add them in the config/theme editor or connect a review app (Judge.me, Loox). This box only shows in the preview.</div>';
      } else return "";
      return '<section class="rg-sec"><div class="rg-wrap rg-fade">' + h2(s.title) + lead(s.lead) + body + "</div></section>";
    },
    faq: function (s) { return '<section class="rg-sec"><div class="rg-wrap rg-fade" style="max-width:760px">' + h2(s.title) + lead(s.lead) + acc(C.faq) + "</div></section>"; },
    guarantee: function (s) {
      var g = C.guarantee || {};
      return '<section class="rg-sec"><div class="rg-wrap rg-fade"><div class="rg-guarantee"><div class="rg-guarantee__seal">' + esc(g.days || 30) + "<small>DAY</small><small>GUARANTEE</small></div><div><b>" + esc(g.title || "") + "</b><p>" + esc(g.text || "") + "</p></div></div></div></section>";
    },
    final: function (s) {
      return '<section class="rg-sec rg-sec--glow rg-final"><div class="rg-wrap rg-fade">' + h2(s.title) + lead(s.lead) + '<button class="rg-atc" data-act="scroll">' + esc(s.cta || "Choose your design") + "</button></div></section>";
    },
    html: function (s) { return '<section class="rg-sec"><div class="rg-wrap">' + (s.html || "") + "</div></section>"; }
  };

  function footer() {
    var f = C.footerLinks || [];
    return '<footer class="rg-footer"><div class="rg-wrap"><nav>' + f.map(function (l) { return '<a href="' + esc(l.url) + '">' + esc(l.label) + "</a>"; }).join("") + "</nav>" + payments() + '<p style="margin-top:14px">© ' + new Date().getFullYear() + " " + esc((C.brand || {}).name || "") + "</p></div></footer>";
  }
  function sticky() {
    var img = C.product.stickyImg || (C.product.images[0] || {}).src || "";
    return '<div class="rg-sticky" data-el="sticky"><img src="' + esc(img) + '" alt=""><div class="rg-sticky__t" data-el="stickyT"></div><button class="rg-atc" data-act="add">' + esc(C.atcShort || "Add to cart") + "</button></div>";
  }

  /* ---------- render ---------- */
  root.className = "rg" + (C.theme ? " theme-" + C.theme : "");
  var ch = C.chrome || {};
  root.innerHTML =
    (ch.announce === false ? "" : announce()) + (ch.header === false ? "" : header()) +
    '<main><div class="rg-wrap rg-product">' + gallery() +
    '<div class="rg-info" id="rg-buy">' + pills() + '<h1 class="rg-title">' + C.product.title + "</h1>" + rating() + priceBlock() + bullets() + timer() + bundles() + designPicker() + upsell() +
    '<button class="rg-atc" data-act="add" data-el="atc"></button>' + trust() + shipping() + quote() + '<div style="margin-top:18px">' + acc(C.info) + "</div></div></div>" +
    (C.sections || []).map(function (s) { return S[s.type] ? S[s.type](s) : ""; }).join("") +
    "</main>" + (ch.footer === false ? '<div style="height:90px"></div>' : footer()) + sticky() + '<div class="rg-toast" data-el="toast" role="status" aria-live="polite"></div>';

  var $ = function (sel) { return root.querySelector(sel); };
  var $$ = function (sel) { return Array.prototype.slice.call(root.querySelectorAll(sel)); };

  /* ---------- update UI from state ---------- */
  function update() {
    var t = tiers[state.tier] || { price: C.product.price, compare: C.product.compare, name: "" };
    var total = t.price + (state.upsell && C.upsell ? C.upsell.price : 0);
    var save = t.compare ? Math.round((1 - t.price / t.compare) * 100) : 0;
    $('[data-el="price"]').innerHTML = '<span class="rg-price__now">' + money(t.price) + "</span>" + (t.compare ? '<span class="rg-price__was">' + money(t.compare) + "</span>" : "") + (save > 0 ? '<span class="rg-price__save">SAVE ' + save + "%</span>" : "");
    $$("[data-tier]").forEach(function (b, i) { b.classList.toggle("on", i === state.tier); b.setAttribute("aria-checked", i === state.tier); });
    var atcLabel = (C.atcLabel || "Add to cart") + " · " + money(total);
    $('[data-el="atc"]').textContent = atcLabel;
    var st = $('[data-el="stickyT"]');
    if (st) st.innerHTML = esc(t.name) + "<span>" + money(total) + (t.compare ? ' <s style="opacity:.6">' + money(t.compare) + "</s>" : "") + "</span>";

    if (designs.length) {
      var n = slotsFor(state.tier);
      var pick = state.picks[state.slot];
      $$("[data-design]").forEach(function (b, i) { b.classList.toggle("on", i === pick); });
      $('[data-el="designName"]').textContent = n > 1 ? "" : (designs[pick] || {}).name || "";
      var unit = C.slotUnit || "Pair";
      $('[data-el="slots"]').innerHTML = n > 1 ? state.picks.map(function (d, i) {
        return '<button class="rg-slot' + (i === state.slot ? " on" : "") + '" data-slot="' + i + '"><img src="' + esc(designs[d].img) + '" alt="">' + esc(unit) + " " + (i + 1) + "</button>";
      }).join("") : "";
      $('[data-el="hint"]').textContent = n > 1 ? "Tap " + unit.toLowerCase() + " " + (state.slot + 1) + ", then pick its design. Mix and match any way you want." : (C.designHint || "");
    }
    var cnt = $('[data-el="count"]'); if (cnt) cnt.textContent = state.count;
  }

  /* ---------- events ---------- */
  root.addEventListener("click", function (e) {
    var el = e.target.closest("[data-tier],[data-design],[data-slot],[data-thumb],[data-act]");
    if (!el) return;
    if (el.hasAttribute("data-tier")) { state.tier = +el.dataset.tier; syncPicks(); update(); }
    else if (el.hasAttribute("data-design")) {
      state.picks[state.slot] = +el.dataset.design;
      if (state.slot < state.picks.length - 1) state.slot++;
      update();
    }
    else if (el.hasAttribute("data-slot")) { state.slot = +el.dataset.slot; update(); }
    else if (el.hasAttribute("data-thumb")) { goSlide(+el.dataset.thumb); }
    else if (el.dataset.act === "add") addToCart(el);
    else if (el.dataset.act === "scroll") document.getElementById("rg-buy").scrollIntoView({ behavior: "smooth", block: "start" });
    else if (el.dataset.act === "cart" && C.cart && C.cart.mode === "shopify") location.href = "/cart";
  });
  var up = $('[data-el="upsell"]');
  if (up) up.addEventListener("change", function () { state.upsell = up.checked; update(); });

  /* gallery */
  var slides = $('[data-el="slides"]');
  function goSlide(i) { slides.scrollTo({ left: slides.clientWidth * i, behavior: "smooth" }); }
  slides.addEventListener("scroll", function () {
    var i = Math.round(slides.scrollLeft / slides.clientWidth);
    $$(".rg-gallery__dots i").forEach(function (d, k) { d.classList.toggle("on", k === i); });
    $$("[data-thumb]").forEach(function (d, k) { d.classList.toggle("on", k === i); });
  }, { passive: true });

  /* countdown (real end date only) */
  var tEl = $('[data-el="timer"]');
  if (tEl) {
    var end = new Date(C.sale.endsAt).getTime();
    var pad = function (n) { return (n < 10 ? "0" : "") + n; };
    var tick = function () {
      var left = Math.max(0, end - Date.now());
      if (!left) { tEl.style.display = "none"; return; }
      var s = Math.floor(left / 1000);
      tEl.querySelector('[data-t="d"]').textContent = pad(Math.floor(s / 86400)) + "d";
      tEl.querySelector('[data-t="h"]').textContent = pad(Math.floor(s % 86400 / 3600)) + "h";
      tEl.querySelector('[data-t="m"]').textContent = pad(Math.floor(s % 3600 / 60)) + "m";
      tEl.querySelector('[data-t="s"]').textContent = pad(s % 60) + "s";
    };
    tick(); window.__rgTimer = setInterval(tick, 1000);
  }

  /* sticky bar: show once main ATC scrolls out of view */
  var sticky = $('[data-el="sticky"]'), mainAtc = $('[data-el="atc"]');
  if ("IntersectionObserver" in window) {
    new IntersectionObserver(function (en) {
      var past = !en[0].isIntersecting && en[0].boundingClientRect.top < 0;
      sticky.classList.toggle("show", past);
    }).observe(mainAtc);
    var fio = new IntersectionObserver(function (en) { en.forEach(function (x) { if (x.isIntersecting) { x.target.classList.add("in"); fio.unobserve(x.target); } }); }, { threshold: .12 });
    $$(".rg-fade").forEach(function (x) { fio.observe(x); });
  } else { $$(".rg-fade").forEach(function (x) { x.classList.add("in"); }); }

  /* toast */
  var toastT;
  function toast(msg) { var t = $('[data-el="toast"]'); t.textContent = msg; t.classList.add("show"); clearTimeout(toastT); toastT = setTimeout(function () { t.classList.remove("show"); }, 2600); }

  /* ---------- cart ---------- */
  function lineProps() {
    var props = {}, unit = C.slotUnit || "Pair", lbl = C.propLabel || "Design";
    if (!designs.length) return props;
    if (state.picks.length === 1) props[lbl] = designs[state.picks[0]].name;
    else state.picks.forEach(function (d, i) { props[lbl + " (" + unit + " " + (i + 1) + ")"] = designs[d].name; });
    return props;
  }
  function addToCart(btn) {
    var t = tiers[state.tier];
    var items;
    if (C.bundleMode === "quantity") {
      // one line per unit so each pair keeps its own design; Shopify merges identical lines
      var qty = t.qty || 1, lbl = C.propLabel || "Design";
      items = [];
      for (var i = 0; i < qty; i++) {
        var props = {};
        if (designs.length) props[lbl] = designs[state.picks[Math.min(i, state.picks.length - 1)]].name;
        var same = items.filter(function (x) { return JSON.stringify(x.properties) === JSON.stringify(props); })[0];
        if (same) same.quantity++; else items.push({ id: t.variantId, quantity: 1, properties: props });
      }
    } else {
      items = [{ id: t && t.variantId, quantity: 1, properties: lineProps() }];
    }
    if (state.upsell && C.upsell && C.upsell.variantId) items.push({ id: C.upsell.variantId, quantity: 1 });

    if (!C.cart || C.cart.mode !== "shopify") {
      state.count += items.reduce(function (a, x) { return a + x.quantity; }, 0); update();
      toast("Preview: added " + t.name + " — " + state.picks.map(function (d) { return designs[d] ? designs[d].name : ""; }).join(", "));
      return;
    }
    btn.disabled = true;
    fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : "/") + "cart/add.js", {
      method: "POST", headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ items: items })
    }).then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
      .then(function () { location.href = C.cart.after === "checkout" ? "/checkout" : "/cart"; })
      .catch(function (err) { btn.disabled = false; toast((err && (err.description || err.message)) || "Couldn't add to cart — please try again."); });
  }

  update();
  }

  boot();
  document.addEventListener("shopify:section:load", boot);
})();
